const ROUTABLE_PREFIXES = [
  '/login',
  '/reset-password',
  '/corporate-kyc',
  '/client',
  '/admin',
];

function normalizeLegacyPath(pathname: string): string {
  if (pathname === '/admin/loan-deals') {
    return '/admin/deals';
  }

  if (pathname.startsWith('/admin/loan-deals/')) {
    return pathname.replace('/admin/loan-deals/', '/admin/deals/');
  }

  return pathname;
}

export function resolveLegacyHashRedirectUrl(locationLike: Pick<Location, 'origin' | 'pathname' | 'search' | 'hash'>): string | null {
  if (locationLike.hash) {
    return null;
  }

  const normalizedPath = normalizeLegacyPath(locationLike.pathname || '/');
  const shouldRewrite = ROUTABLE_PREFIXES.some((prefix) => normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`));

  if (!shouldRewrite) {
    return null;
  }

  return `${locationLike.origin}/#${normalizedPath}${locationLike.search || ''}`;
}
